module.exports = __webpack_public_path__ + "media/images/img-hobby-11-7a3e31ec.jpg";